/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsseriesactive2Inputs */

const en_statsseriesactive2 = /** @type {(inputs: Statsseriesactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active accounts`)
};

const de_statsseriesactive2 = /** @type {(inputs: Statsseriesactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Konten`)
};

/**
* | output |
* | --- |
* | "Active accounts" |
*
* @param {Statsseriesactive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsseriesactive2 = /** @type {((inputs?: Statsseriesactive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsseriesactive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsseriesactive2(inputs)
	return de_statsseriesactive2(inputs)
});
export { statsseriesactive2 as "statsSeriesActive" }